import {call, put} from "redux-saga/effects";
import { push } from 'connected-react-router'

import {
  receiveScheduleData,
  noResultsScheduleData,
  errorRetrievingSchedulesData,
  setRequestedScheduleDataFlag
} from "../actions/schedulesDataActions";
import {fetchScheduleData} from "../api/scheduleDataApi";

// worker Saga: will be fired on USER_FETCH_REQUESTED actions
export default function* getScheduleData(action) {
  try {
    // do api call
    const data = yield call(fetchScheduleData, action.payload);
    const routeData = data.routes;
    if (routeData === null || routeData.length === 0) {
      yield put(noResultsScheduleData());
    } else {
      yield put(receiveScheduleData(data));
      yield put(setRequestedScheduleDataFlag());

      let routeParams = action.payload;

      delete routeParams.nonRevAndRevFacilities;

      yield put(push("/ship/flight-schedules/results?" +
        Object.keys(routeParams).sort().map(key => key + '=' + routeParams[key]).join('&')));
    }
  } catch (e) {
    yield put(errorRetrievingSchedulesData(e.message));
    yield put(push('/ship/flight-schedules/'));
  }
}




// WEBPACK FOOTER //
// ./src/sagas/scheduleSaga.js